// src/components/ConclusaoModal.jsx
import React, { useState, useEffect } from 'react';

const API_URL = window.location.hostname === 'localhost' 
  ? 'http://localhost:3001/api' 
  : '/api';

function ConclusaoModal({ isOpen, onClose, oportunidade, onConfirmar }) {
  const [dados, setDados] = useState({
    nome_cliente: '',
    telefone: '',
    valor: 0,
    tipo_servico: 'com_cobranca',
    tecnico_id: '',
    forma_pagamento: 'pix'
  });

  const [tecnicos, setTecnicos] = useState([]);
  const [enviando, setEnviando] = useState(false);

  useEffect(() => {
    if (isOpen && oportunidade) {
      setDados({
        nome_cliente: oportunidade.cliente_nome || '',
        telefone: '',
        valor: oportunidade.valor_real || 0,
        tipo_servico: oportunidade.valor_real > 0 ? 'com_cobranca' : 'sem_cobranca',
        tecnico_id: oportunidade.tecnico_id || '',
        forma_pagamento: 'pix'
      });

      carregarTecnicos();
    }
  }, [isOpen, oportunidade]);

  const carregarTecnicos = async () => {
    try {
      const response = await fetch(`${API_URL}/tecnicos`);
      const data = await response.json();
      setTecnicos(data.tecnicos || []);
    } catch (error) {
      console.error('Erro ao carregar técnicos:', error);
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!dados.nome_cliente) {
      alert('Nome do cliente é obrigatório!');
      return;
    }

    if (!dados.telefone) {
      alert('Telefone é obrigatório!');
      return;
    }

    if (!dados.tecnico_id) {
      alert('Selecione o técnico!');
      return;
    }

    setEnviando(true);

    try {
      await onConfirmar(dados);
      onClose();
    } catch (error) {
      console.error('Erro ao enviar conclusão:', error);
      alert('Erro ao enviar notificação!');
    } finally {
      setEnviando(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className="modal-content modal-large" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>✅ Concluir Serviço - OS #{oportunidade?.titulo?.match(/\d+/)?.[0]}</h2>
          <button className="modal-close" onClick={onClose}>&times;</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">

            <div className="info-section">
              <h3>Tipo de Serviço</h3>
              <div className="radio-group">
                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="com_cobranca"
                    checked={dados.tipo_servico === 'com_cobranca'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>💰 Com Cobrança</span>
                </label>

                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="sem_cobranca"
                    checked={dados.tipo_servico === 'sem_cobranca'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>🎁 Sem Cobrança (Garantia/Cortesia)</span>
                </label>

                <label className="radio-option">
                  <input
                    type="radio"
                    name="tipo_servico"
                    value="ja_pago"
                    checked={dados.tipo_servico === 'ja_pago'}
                    onChange={(e) => setDados({...dados, tipo_servico: e.target.value})}
                  />
                  <span>✅ Já Pago</span>
                </label>
              </div>
            </div>

            <div className="info-section">
              <h3>Dados do Cliente</h3>
              <div className="form-grid">
                <div className="form-group">
                  <label>Nome do Cliente *</label>
                  <input
                    type="text"
                    value={dados.nome_cliente}
                    onChange={(e) => setDados({...dados, nome_cliente: e.target.value})}
                    placeholder="Nome completo"
                    required
                  />
                </div>

                <div className="form-group">
                  <label>Telefone (WhatsApp) *</label>
                  <input
                    type="tel"
                    value={dados.telefone}
                    onChange={(e) => setDados({...dados, telefone: e.target.value})}
                    placeholder="16999999999"
                    required
                  />
                  <small>Apenas números (DDD + número)</small>
                </div>
              </div>
            </div>

            <div className="info-section">
              <h3>Técnico Responsável</h3>
              <div className="form-group">
                <label>Selecione o Técnico *</label>
                <select
                  value={dados.tecnico_id}
                  onChange={(e) => setDados({...dados, tecnico_id: e.target.value})}
                  required
                >
                  <option value="">Selecione...</option>
                  {tecnicos.map(tec => (
                    <option key={tec.id} value={tec.id}>
                      {tec.nome}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            {dados.tipo_servico === 'com_cobranca' && (
              <div className="info-section">
                <h3>Valor do Serviço</h3>
                <div className="form-group">
                  <label>Valor Total *</label>
                  <input
                    type="number"
                    step="0.01"
                    value={dados.valor}
                    onChange={(e) => setDados({...dados, valor: parseFloat(e.target.value)})}
                    placeholder="0.00"
                    required
                  />
                  <small>As formas de pagamento serão calculadas automaticamente</small>
                </div>
              </div>
            )}

            <div className="info-section">
              <h3>📱 Prévia da Mensagem</h3>
              <div style={{
                background: '#f5f5f5',
                padding: '15px',
                borderRadius: '8px',
                whiteSpace: 'pre-line',
                fontSize: '14px',
                border: '1px solid #ddd'
              }}>
                {gerarPrevia(dados, tecnicos)}
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button
              type="button"
              onClick={onClose}
              className="btn-secondary"
              disabled={enviando}
            >
              Cancelar
            </button>
            <button
              type="submit"
              className="btn-primary"
              disabled={enviando}
            >
              {enviando ? '⏳ Enviando...' : '✅ Enviar e Finalizar'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

function gerarPrevia(dados, tecnicos) {
  const saudacao = getSaudacao();
  const tecnico = tecnicos.find(t => t.id === parseInt(dados.tecnico_id));
  const tecnicoNome = tecnico ? tecnico.nome : '[Selecione o técnico]';
  const valorTotal = parseFloat(dados.valor) || 0;
  const valorComDescontoPix = valorTotal * 0.95;

  if (dados.tipo_servico === 'com_cobranca') {
    let formasPagamento = '';

    const valorFormatadoPix = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorComDescontoPix);

    formasPagamento += `📱 *PIX com 5% de desconto:* ${valorFormatadoPix}\n`;
    formasPagamento += `   CNPJ: 27.820.945/0001-06\n\n`;

    if (valorTotal >= 100) {
      const opcoesBoleto = calcularParcelamentoBoleto(valorTotal);
      formasPagamento += `📄 *Boleto Bancário:*\n`;

      if (opcoesBoleto.length === 1) {
        formasPagamento += `   À vista: ${opcoesBoleto[0].descricao.split(': ')[1]}\n\n`;
      } else {
        opcoesBoleto.forEach(opcao => {
          formasPagamento += `   ${opcao.descricao}\n`;
        });
        formasPagamento += `\n`;
      }
    }

    const valorParcela = valorTotal / 4;
    const valorParcelaFormatado = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorParcela);

    formasPagamento += `💳 *Cartão de Crédito:*\n`;
    formasPagamento += `   Em até 4x de ${valorParcelaFormatado} sem juros`;

    const valorFormatado = new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(valorTotal);

    return `${saudacao} ${dados.nome_cliente || '[Nome]'}!

A ordem de serviço já foi concluída pelo técnico ${tecnicoNome}.

💰 *Valor:* ${valorFormatado}

*As formas de pagamento disponíveis para este atendimento são:*

${formasPagamento}

Caso tenha alguma dúvida, pode entrar em contato por este canal mesmo.

O Grupo GVS agradece pela confiança, conte sempre conosco! 🙏`;
  }

  if (dados.tipo_servico === 'sem_cobranca') {
    return `${saudacao} ${dados.nome_cliente || '[Nome]'}!

A ordem de serviço já foi concluída pelo técnico ${tecnicoNome}.

Este serviço não gerou nenhum tipo de cobrança. 🎁

Caso tenha alguma dúvida, pode entrar em contato por este canal mesmo.

O Grupo GVS agradece pela confiança, conte sempre conosco! 🙏`;
  }

  return `${saudacao} ${dados.nome_cliente || '[Nome]'}!

A ordem de serviço já foi concluída pelo técnico ${tecnicoNome}.

Caso tenha alguma dúvida, pode entrar em contato por este canal mesmo.

O Grupo GVS agradece pela confiança, conte sempre conosco! 🙏`;
}

function calcularParcelamentoBoleto(valorTotal) {
  const opcoes = [];
  const formatarValor = (valor) => new Intl.NumberFormat('pt-BR', {
    style: 'currency',
    currency: 'BRL'
  }).format(valor);

  if (valorTotal < 100) {
    return opcoes;
  }

  if (valorTotal < 200) {
    opcoes.push({
      descricao: `À vista: ${formatarValor(valorTotal)}`
    });
  }
  else if (valorTotal < 500) {
    const valor2x = valorTotal / 2;
    if (valor2x >= 100) {
      opcoes.push({
        descricao: `2x de ${formatarValor(valor2x)} (vencimento em 7 e 28 dias)`
      });
    } else {
      opcoes.push({
        descricao: `À vista: ${formatarValor(valorTotal)}`
      });
    }
  }
  else {
    const valor4x = valorTotal / 4;
    if (valor4x >= 100) {
      opcoes.push({
        descricao: `4x de ${formatarValor(valor4x)} (vencimento a cada 22 dias)`
      });
    }

    const valor3x = valorTotal / 3;
    if (valor3x >= 100) {
      opcoes.push({
        descricao: `3x de ${formatarValor(valor3x)} (vencimento a cada 30 dias)`
      });
    }

    const valor2x = valorTotal / 2;
    opcoes.push({
      descricao: `2x de ${formatarValor(valor2x)} (vencimento em 7 e 28 dias)`
    });
  }

  return opcoes;
}

function getSaudacao() {
  const hora = new Date().getHours();

  if (hora >= 6 && hora < 12) {
    return '🌅 Bom dia';
  } else if (hora >= 12 && hora < 18) {
    return '☀️ Boa tarde';
  } else {
    return '🌙 Boa noite';
  }
}

export default ConclusaoModal;